import React, { useState, useEffect } from "react";
import { Edit,useDataProvider, useGetIdentity, useListController,useGetOne,FormDataConsumer, useRedirect, useEditController, SimpleForm, useGetList, TextInput, DateInput, required, BooleanInput, NumberInput, SelectInput, ReferenceInput   } from 'react-admin';
import { Grid } from '@mui/material';
import moment from 'moment'
import 'moment/locale/fr'
import { dataProvider } from "../providers/dataProviderHydra";
import { RichTextInput } from 'ra-input-rich-text';
import { useLocation } from 'react-router-dom';


const FishStockingEdit = (props) => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const { data } = useGetList('campaigns', {
    sort: { field: 'name', order: 'ASC' },
    pagination: {page: 1, perPage: 1000},
  });
  let choices = [];
  if (data !== undefined) {
    data.map((campaign, index) => {
      moment.locale('fr');
      const startDate = moment(campaign.startDate).format('YYYY');
      const endDate = moment(campaign.endDate).format('YYYY');
      choices[index] =
          {
            id: campaign.id,
            name: startDate+" / "+endDate
          };


    });
  }
  const { record, isLoading } = useEditController();
  let [stockingOriginSuccess, setStockingOriginSuccess] = useState(null);

  const { data: identity } = useGetIdentity();
  const [fetchedPrice, setFetchedPrice] = useState(null);
  useEffect(() => {
    if (!record || !record.fishPrice) return;

    // Si la ressource est déjà embarquée dans record.fishPrice
    if (
        typeof record.fishPrice === 'object' &&
        (record.fishPrice.costPrice != null ||
            record.fishPrice.purchaseRateCollector != null ||
            record.fishPrice.disposalFeeCollector != null)
    ) {
      const raw =
          record.fishPrice.costPrice ??
          record.fishPrice.purchaseRateCollector ??
          record.fishPrice.disposalFeeCollector ??
          null;
      const num = typeof raw === 'string' ? parseFloat(raw) : raw;
      setFetchedPrice(Number.isFinite(num) ? num : null);
      return;
    }

    // Sinon, extraire un identifiant/IRI et faire getOne
    const toNumericId = (v) => {
      if (v == null) return null;
      if (typeof v === 'number') return String(v);
      if (typeof v === 'string') {
        const last = v.split('/').filter(Boolean).pop();
        return last || null;
      }
      if (typeof v === 'object') {
        if (v.id != null) return String(v.id);
        if (v['@id']) {
          const last = v['@id'].split('/').filter(Boolean).pop();
          return last || null;
        }
      }
      return null;
    };
    const toIri = (v) => {
      if (v == null) return null;
      if (typeof v === 'string') return v.startsWith('/fish_prices/') ? v : `/fish_prices/${v}`;
      if (typeof v === 'number') return `/fish_prices/${v}`;
      if (typeof v === 'object') {
        if (v['@id']) return v['@id'];
        if (v.id != null) return `/fish_prices/${v.id}`;
      }
      return null;
    };

    const numeric = toNumericId(record.fishPrice);
    const iri = toIri(record.fishPrice);
    const candidates = [iri, numeric].filter(Boolean);

    (async () => {
      for (const candidate of candidates) {
        try {
          const { data } = await dataProvider.getOne('fish_prices', { id: candidate });
          const raw = data?.costPrice ?? data?.purchaseRateCollector ?? data?.disposalFeeCollector ?? null;
          const num = typeof raw === 'string' ? parseFloat(raw) : raw;
          setFetchedPrice(Number.isFinite(num) ? num : null);
          return;
        } catch (err) {
          // on essaie le candidat suivant
        }
      }
      // si aucun candidat n'a marché, fallback sera géré plus bas (defaultValue 10)
      setFetchedPrice(null);
    })();
  }, [record, dataProvider]);
  console.log(fetchedPrice);

  const onSuccess = async (response, { data, previousData }) => {

    const record = response ?? previousData ?? {};
    const stockingId =
        record?.id ?? (record?.['@id'] ? record['@id'].split('/').pop() : null);

    // 1) Créer un fish_price si un prix est saisi
    let fishPricePayload = null;
    if (data?.price != null && data.price !== '') {
      const created = await dataProvider.create('fish_prices', {
        data: {
          campaign: record.campaign,
          specieFish: record.specieFish,
          user: `/users/${identity.id}`,
          costPrice: data.price,
          disposalFeeCollector: data.price,
          purchaseRateCollector: data.price,
        },
      });
      const createdData = created?.data ?? created;
      const iri = createdData?.['@id'];
      const idNum = createdData?.id ?? (iri ? iri.split('/').pop() : null);
      fishPricePayload = iri ?? (idNum ? `/fish_prices/${idNum}` : null);
    }

    // 2) Patch minimal
    const patch = {};
    if (stockingOriginSuccess === '/stocking_origins/2' && record.waterBodyStockingOrigin != null) {
      patch['waterBodyStockingOrigin'] = null;
    } else if (stockingOriginSuccess === '/stocking_origins/1' && record.collector != null) {
      patch['collector'] = null;
    }
    if (fishPricePayload != null) patch['fishPrice'] = fishPricePayload;

    // 3) Update si besoin
    if (stockingId && Object.keys(patch).length > 0) {
      await dataProvider.update('action_fish_stockings', {
        id: stockingId,
        data: { ...record, ...patch },
        previousData: record,
      });
    }

    if (record) {
      console.log(stockingOriginSuccess);
      if (stockingOriginSuccess === "/stocking_origins/2" && record.waterBodyStockingOrigin !== null) { // Si Vendu et waterBodyStockingOrigin existe
        await dataProvider.update('action_fish_stockings', { id: record.id, data: { waterBodyStockingOrigin: null } });
      } else if (stockingOriginSuccess === "/stocking_origins/1" && record.collector !== null) { // Si Gardé et Collector existe
        await dataProvider.update('action_fish_stockings', { id: record.id, data: { collector: null } });
      }
    }
    const searchParams = new URLSearchParams(location.search);
    const isBasin = searchParams.get('isBasin') === 'true';
    const basinParam = isBasin ? '&isBasin=true' : '';
    redirect({
      pathname: '/action_fish_stockings',
      search: `filter=${JSON.stringify({ waterBody: record.waterBody })}${basinParam}`,
    });
  };

  let current = useListController();
  function GetNameSpieces(id) {
    const  spieciesName = useGetOne('specie_fishes', { id: id });
    if(spieciesName.data)  {
      return spieciesName.data.name;
    } else {
      return spieciesName.data;
    }
  }
  function GetDefaultId(id) {
    const { data } = useGetList('specie_fishes/uniq');
    console.log(data);
    if (data !== undefined) {
      const test = data.filter(({name}) => name === GetNameSpieces(id));
    }


  }
  const formatSpecieFish = (record) => {
    if (!record.stage) {
      record.stage = "Stade non connu";
    }
    return record.stage;
  };

  const firstChoice = (formData) => {
    const datas = GetDefaultId(formData.specieFish)
    console.log("test",datas);


  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isBasin = searchParams.get('isBasin') === 'true';
  const waterBodyId = record?.waterBody;

  const {
    data: waterBody,
    isLoading: isWaterBodyLoading,
  } = useGetOne(
      'water_bodies',
      { id: waterBodyId },
      { enabled: !!waterBodyId }   // évite la requête tant qu'il n'y a pas d'id
  );

  const waterBodyType = waterBody?.waterBodyType;
  console.log("waterBodyType :", waterBodyType);
  return(
      <Edit mutationOptions={{ onSuccess }}  mutationMode="pessimistic" sanitizeEmptyValues>
        <h1 className={"titleName"}>{current !== undefined ? current.defaultTitle : ''} - {waterBody.data !== undefined ? waterBody.data.name : ''}</h1>
        <SimpleForm sanitizeEmptyValues>
          <Grid container>
            <Grid item xs={6}>
              <SelectInput source="campaign" choices={choices} label="Campagne" validate={[required()]} fullWidth />
            </Grid>
          </Grid>
          {waterBodyType === "/water_body_types/2" && (
          <Grid container>
            <Grid item xs={6}>
              <SelectInput
                source="affiliation"
                label="Affiliation de l'action"
                choices={[
                  { id: 'Production estivale 1', name: 'Production estivale 1' },
                  { id: 'Production estivale 2', name: 'Production estivale 2' },
                  { id: 'Stockage hivernal 1', name: 'Stockage hivernal 1' },
                  { id: 'Stockage hivernal 2', name: 'Stockage hivernal 2' }
                ]}
                validate={[required()]}
                fullWidth
              />
            </Grid>
          </Grid>
        )}
          <Grid container>
            <Grid item xs={6}>
              <ReferenceInput source="specieFish"  reference="specie_fishes/uniq">
                <SelectInput optionText="name" label="Espèce" validate={[required()]} fullWidth />
              </ReferenceInput>
            </Grid>
          </Grid>
          <FormDataConsumer>
            {({ formData, ...rest }) => formData.specieFish &&
              <Grid container>
                <Grid item xs={6}>
                  <ReferenceInput source="specieFish" reference={"specie_fishes?name="+GetNameSpieces(formData.specieFish)}>
                    <SelectInput  optionText={formatSpecieFish} label="Stade espèce"  fullWidth />
                  </ReferenceInput>
                </Grid>
              </Grid>
            }
          </FormDataConsumer>
          <Grid container>
            <Grid item xs={6} className={"itemForm1"}>
              <NumberInput source="numberHead" label="Nombre de tête(s)"   fullWidth  onWheel={(e) => e.target.blur()} />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={3} className={"itemForm1"}>
              <NumberInput source="averageWeight" label="Poids moyen (en kg)" fullWidth onWheel={(e) => e.target.blur()} />
            </Grid>
            <Grid item xs={3} className={"itemForm2"}>
              <NumberInput source="totalWeight" label="Poids total (en kg)"  validate={[required()]} fullWidth onWheel={(e) => e.target.blur()} />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <ReferenceInput source="stockingOrigin"  reference="stocking_origins">
                <SelectInput optionText="name" label="Origine" validate={[required()]} fullWidth />
              </ReferenceInput>
            </Grid>
          </Grid>
          <FormDataConsumer>
            {({ formData, ...rest }) => formData.stockingOrigin === "/stocking_origins/2" &&
                <Grid container>
                  <Grid item xs={6}>
                    <ReferenceInput source="collector"  reference="collectors">
                      <SelectInput optionText="name" label="Collecteur"  fullWidth onChange={setStockingOriginSuccess('/stocking_origins/2')}/>
                    </ReferenceInput>
                  </Grid>
                </Grid>
            }
          </FormDataConsumer>
          <FormDataConsumer>
            {({ formData, ...rest }) => formData.stockingOrigin === "/stocking_origins/1" &&
                <Grid container>
                  <Grid item xs={6}>
                    <ReferenceInput source="waterBodyStockingOrigin"  reference="water_bodies" perPage={5000}>
                      <SelectInput optionText="name" label="Liste étangs/bassins"  fullWidth onChange={setStockingOriginSuccess('/stocking_origins/1')}/>
                    </ReferenceInput>
                  </Grid>
                </Grid>
            }
          </FormDataConsumer>

          <Grid container>
            <Grid item xs={6} className={"itemForm1"}>
              <DateInput  source="date" label="Date" validate={[required()]} fullWidth />
            </Grid>
          </Grid>


          <FormDataConsumer>
            {({ formData, ...rest }) => formData.stockingOrigin === "/stocking_origins/1" &&
              <Grid container>
                <Grid item xs={6}>
                  <NumberInput
                      // key={`price-${fetchedPrice ?? '10'}`}   // force remount à l’arrivée de fetchedPrice
                      source="price"
                      label="Coût unitaire (en € HT /kg)"
                      fullWidth
                      defaultValue={fetchedPrice}        // costPrice si dispo, sinon 10
                      onWheel={(e) => e.target.blur()}
                  />
                </Grid>
              </Grid>
            }
          </FormDataConsumer>

          <FormDataConsumer>
            {({ formData, ...rest }) => formData.stockingOrigin === "/stocking_origins/2" &&
              <Grid container>
                <Grid item xs={6}>
                  <NumberInput
                      // key={`price-${fetchedPrice ?? '10'}`}   // force remount à l’arrivée de fetchedPrice
                      source="price"
                      label="Coût unitaire (en € HT /kg)"
                      fullWidth
                      defaultValue={fetchedPrice}        // costPrice si dispo, sinon 10
                      onWheel={(e) => e.target.blur()}
                  />
                </Grid>
              </Grid>
            }
          </FormDataConsumer>
          <Grid container>
          <Grid item xs={6}>
            <TextInput source="note" label="Remarque(s)" multiline fullWidth />
          </Grid>
        </Grid>
          <TextInput source="waterBody" className={"hidden"} type={"hidden"}/>
        </SimpleForm>
      </Edit>
  );
}


export default FishStockingEdit;
